import { Right } from './right';

/**
 * Module
 */
export class Module {
  /**
   * Module key name
   */
  module: string;

  /**
   * Right
   */
  right: string;

  /**
   * Description
   */
  description: string;

  /**
   * Module name
   */
  moduleName: {
    name: string;
  };

  /**
   * Right object
   */
  rightObj: Right;

  /**
   * Constructor
   *
   * @param module Module
   * @param right Right
   * @param description Description
   * @param moduleName Module name
   */
  constructor(module?: string, right?: string, description?: string, moduleName?: { name: string }) {
    this.module = module;
    this.right = right;
    this.description = description;
    this.moduleName = moduleName;
  }

  /**
   * Create from json
   *
   * @param json Json with data
   *
   * @return self
   */
  static createFromJson(json: any): Module {
    const self = new this();

    Object.keys(self).forEach((key) => {
      if (key === 'moduleName') {
        self.moduleName = json?.UserModules?.name;
      } else {
        self[key] = json[key];
      }
    });
    return self;
  }
}
